import { render, staticRenderFns } from "./DepartmentModalForm.vue?vue&type=template&id=6a6c56b8"
import script from "./DepartmentModalForm.vue?vue&type=script&lang=js"
export * from "./DepartmentModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports